import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SalesAndDealsForm from "../../Components/SalesAndDeals/SalesAndDealsForm";
import useApi from "../../Hooks/useApi";
import { getsales } from "../../api/getapi";

function SalesAndDealsFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editingDeal, setEditingDeal] = useState(null);
  const [loading, setLoading] = useState(id ? true : false);
  const { request: getSales } = useApi(getsales);

  useEffect(() => {
    if (id) {
      getSales().then((res) => {
        const deals = res?.data?.data || res?.data || [];
        const deal = Array.isArray(deals) ? deals.find((d) => String(d.sale_id) === String(id)) : null;
        setEditingDeal(deal || null);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    }
  }, [id]);

  const handleFormSubmit = () => {
    navigate("/marketplace-options/sales-deals");
  };

  const handleClose = () => {
    navigate("/marketplace-options/sales-deals");
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
        <span className="spinner-border spinner-border-sm text-primary me-2" />
        Loading deal...
      </div>
    );
  }

  return (
    <SalesAndDealsForm
      editingDeal={editingDeal}
      onFormSubmit={handleFormSubmit}
      setShowForm={handleClose}
    />
  );
}

export default SalesAndDealsFormPage;
